import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { checkAssessment, getUserEvalInfo } from "../../axios/axiosFunctions";
import { Container } from "@mui/material";
import bgImage from '../../assets/images/bgImage.png';
import { useState } from "react";
import Welcome360 from "./Welcome360";
import Assessment360Block from "./Assessment360Block";
import Thanks360 from "../../components/Thanks360";

const Assessment360 = () => {

    const navigate = useNavigate();
    const {assessmentSlug,userEvalId,userId} = useParams();
    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(true);
    const [currentAssessment, setCurrentAssessment] = useState();
    const [currentBlock, setCurrentBlock] = useState();
    const [buttonsDir, setButtonsDir] = useState({ before: null, after: null });
    const [revieweeName, setRevieweeName] = useState("");

    useEffect(() => {
        const getAssessment = async()=>{
            const {assessment} = await checkAssessment(assessmentSlug,userEvalId,userId);
            if(!assessment){
                navigate('/');
                return;
            }
            setCurrentAssessment(assessment);

            // Fetch reviewee info for personalized welcome text
            try {
                const userInfo = await getUserEvalInfo(userEvalId);
                if (userInfo?.user?.firstName) {
                    setRevieweeName(`${userInfo.user.firstName} ${userInfo.user.lastName || ""}`.trim());
                }
            } catch (err) {
                console.log("Error fetching reviewee info:", err);
            }

            setLoading(false);
        }
        getAssessment();
    }, []);

    useEffect(() => {
        if(currentAssessment && currentBlock){

            const pos = currentAssessment.blocks.findIndex(block => block._id === currentBlock._id);
            const lastIndex = currentAssessment.blocks.length - 1;

            setButtonsDir({
                before: pos > 0 ? currentAssessment?.blocks[pos - 1] : null,
                after: pos < lastIndex ? currentAssessment?.blocks[pos + 1] : null,
            });
        }
    }, [currentBlock])


    const changeTab = (t)=>{
        setTab(t);
    }

    return (
    <Container maxWidth={false} sx={{padding:tab === 0?"0px":"0px !important",backgroundColor:tab === 0?"#fff":"transparent"}}>
        {
            tab === 0 && <Welcome360 loading={loading} introText={currentAssessment?.introText} mainImage={currentAssessment?.mainImage}
            name={currentAssessment?.name} blocks={currentAssessment?.blocks} id={currentAssessment?._id} changeTab={changeTab} setCurrentBlock={setCurrentBlock}
            assessmentId={currentAssessment?._id} revieweeName={revieweeName} assessmentSlug={assessmentSlug}/>
        }
        {
            tab === 1 && <Assessment360Block currentBlock={currentBlock} buttonsDir={buttonsDir} changeTab={changeTab} setCurrentBlock={setCurrentBlock}/>
        }
        {
            tab === 2 && <Thanks360 name={currentAssessment?.name} mainImage={currentAssessment?.mainImage} revieweeName={revieweeName} assessmentSlug={assessmentSlug} isReviewee={userId === userEvalId}/>
        }
    </Container>
    )
}

export default Assessment360
